export const CLIENT_ID = 'angstrom';
export const SCOPE = 'openid profile offline_access sisapi v1.angstrom.cfb v2.api.cfb';
export const APP_URLS = {
  PROD: ['https://banjo-gameday.sisgaming.com', 'https://dc6hfbh7lw2jc.cloudfront.net'],
  TEST: ['https://banjo-training.sisgaming.com', 'https://d7u5ogacj6qb6.cloudfront.net'],
  DEV: 'http://localhost:3333',
};
export const AUTH_URLS = {
  PROD: 'https://auth.sportsinfosolutions.com',
  DEV: 'https://auth.bistesting.com',
};
export const SIS_API_URLS = {
  PROD: 'https://api.sportsinfosolutions.com',
  DEV: 'https://api.bistesting.com',
};
export const ANGSTROM_API_URLS = {
  PROD: 'https://txxdkh8xrj.execute-api.us-east-2.amazonaws.com/prod',
  DEV: 'https://txxdkh8xrj.execute-api.us-east-2.amazonaws.com/test',
};
export const AUTH_ERROR_RESPONSES = [401, 403, 435];
